import React from 'react'
import { FaQuestion } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type AskControlProps = {
  onClick: () => void
  isFetching?: boolean | undefined
}

const AskControl = ({ onClick, isFetching }: AskControlProps) => {
  const handleClick = () => {
    if (isFetching) {
      return
    }
    onClick()
  }

  return (
    <div className={cn('control', 'ask')} data-graph-type="control" title="Ask a Question">
      <a className={cn('icon', { disabled: isFetching })} onClick={handleClick}>
        <FaQuestion aria-hidden />
        <span className="sr-only">Ask</span>
      </a>
    </div>
  )
}

export default AskControl
